<template>
  <div class="my-course-tag">
    <van-icon name="checked" class="my-course-tag__icon" />
    <span class="my-course-tag__text">已兑换</span>
  </div>
</template>

<script>
export default {
  name: 'MyCourseTag'
}
</script>

<style scoped lang="scss">
.my-course-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 4px 8px;
  border-radius: 6px;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}

.my-course-tag__icon {
  font-size: 11px;
  color: #FFFFFF;
  font-weight: bold;
}

.my-course-tag__text {
  font-size: 10px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 1.2;
  white-space: nowrap;
}
</style>
